import { render, staticRenderFns } from "./SignupHeader.vue?vue&type=template&id=35436b52&scoped=true&"
import script from "./SignupHeader.vue?vue&type=script&lang=js&"
export * from "./SignupHeader.vue?vue&type=script&lang=js&"
import style0 from "./SignupHeader.vue?vue&type=style&index=0&id=35436b52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35436b52",
  null
  
)

export default component.exports